// Copyright (c) Ping. All rights reserved.
//
// Bottom-nav "More" menu — Figma DS (4363:18187): Background effects, Annotate
// (draw), View participants.

import { Pressable, Text, View } from 'react-native';

import { Circle, MonitorSmartphone, Pencil, Sparkles, Users } from 'lucide-react-native';

import { useCallIconColors } from './callTheme';

export function MoreMenu({
  drawMode,
  isRecording,
  recordingAvailable = true,
  onBackgroundEffects,
  onToggleDraw,
  onToggleRecording,
  onHandoff,
  onViewParticipants,
}: {
  drawMode: boolean;
  isRecording: boolean;
  recordingAvailable?: boolean;
  onBackgroundEffects: () => void;
  onToggleDraw: () => void;
  onToggleRecording: () => void;
  onHandoff: () => void;
  onViewParticipants: () => void;
}): JSX.Element {
  const ic = useCallIconColors().primary;
  return (
    <View className="w-[240px] rounded-[12px] border border-[#E1E3E8] dark:border-[#2F333B] bg-white dark:bg-[#15171C] p-[4px]">
      <Row icon={<Sparkles size={16} color={ic} />} label="Background effects" onPress={onBackgroundEffects} />
      <Row
        icon={<Pencil size={16} color={drawMode ? '#537EFF' : ic} />}
        label={drawMode ? 'Stop annotating' : 'Annotate'}
        onPress={onToggleDraw}
      />
      {recordingAvailable ? (
        <Row
          icon={<Circle size={16} color={isRecording ? '#FF5353' : ic} fill={isRecording ? '#FF5353' : 'transparent'} />}
          label={isRecording ? 'Stop recording' : 'Record call'}
          onPress={onToggleRecording}
        />
      ) : null}
      <Row icon={<MonitorSmartphone size={16} color={ic} />} label="Move to another device" onPress={onHandoff} />
      <Row icon={<Users size={16} color={ic} />} label="View participants" onPress={onViewParticipants} />
    </View>
  );
}

function Row({
  icon,
  label,
  onPress,
}: {
  icon: React.ReactNode;
  label: string;
  onPress: () => void;
}): JSX.Element {
  return (
    <Pressable
      onPress={onPress}
      className="h-[36px] flex-row items-center gap-[12px] rounded-[8px] px-[12px] active:bg-black/[0.05] dark:active:bg-white/[0.06]"
    >
      {icon}
      <Text className="text-[14px] text-[#15171C] dark:text-[#F5F6F8]">{label}</Text>
    </Pressable>
  );
}
